import React from 'react';
import './discount.scss';

export default function Discount({ discount }) {
  return (
    <div className='discount-container'>
      {/* <span className='discount-star'>*</span> */}
      <span className='discount-value'>
        {discount || 30}
        <span className='discount-sign'>%</span>
      </span>
      <img src={require('./../../img/discount.svg')} alt='' />
    </div>
  );
}
